// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__2tUq0","paymentContainer":"PaymentPage_paymentContainer__2ie3M"};